import React, { useState, useRef } from 'react'
import { Button, Icon, Spin, Tooltip, message } from 'antd'
import ImageCropperModal from '../../../../../../../components/ImageCropperModal'
import { usePresignedUpload } from '../../../../../hooks/usePresignedUpload'
import './ImageUploader.scss'

const ImageUploader = ({ videoId, aspectRatio, onUploadComplete, disabled, buttonStyle = 'circle' }) => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [cropperVisible, setCropperVisible] = useState(false)
  const fileInputRef = useRef(null)

  const { uploadFiles, isUploading } = usePresignedUpload({ videoId })

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      setSelectedFile(file)
      setCropperVisible(true)
    }
    e.target.value = ''
  }

  const handleCropComplete = async croppedFile => {
    setCropperVisible(false)
    setSelectedFile(null)

    try {
      const response = await uploadFiles({
        files: [croppedFile],
        category: 'image'
      })

      if (response.success && response.urls?.[0]) {
        onUploadComplete(response.urls[0])
        message.success('Image uploaded')
      } else {
        throw response.error || new Error('Upload failed')
      }
    } catch (error) {
      message.error('Upload failed')
      console.error('Upload failed', error)
    }
  }

  const handleCropperCancel = () => {
    setCropperVisible(false)
    setSelectedFile(null)
  }

  return (
    <div className="image-uploader">
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept="image/*"
      />

      <Tooltip title="Upload reference image">
        <Button
          shape={buttonStyle === 'circle' ? 'circle' : undefined}
          icon={isUploading ? 'loading' : (buttonStyle === 'circle' ? 'plus' : 'upload')}
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled || isUploading}
          className="upload-btn"
          style={buttonStyle === 'full' ? { height: 40, width: 'auto' } : undefined}
        >
          {buttonStyle === 'full' && !isUploading ? ' Upload' : null}
          {buttonStyle === 'full' && isUploading ? ' Uploading' : null}
        </Button>
      </Tooltip>

      <ImageCropperModal
        visible={cropperVisible}
        imageFile={selectedFile}
        aspectRatio={aspectRatio || '16:9'}
        onCancel={handleCropperCancel}
        onCrop={handleCropComplete}
      />
    </div>
  )
}

export default ImageUploader
